import React, { useEffect } from "react";
import NoticeSkeleton from "./skeletons/NoticeSkeleton";
import { enchanceTargetLink } from "../utils/Utils";

const Notice = ({ desc, loading }) => {
  useEffect(() => {
    if (desc && !loading) {
      enchanceTargetLink(".r_detailsAdditionalText a");
    }
  }, [desc, loading]);

  if (loading) return <NoticeSkeleton />;

  return (
    <div>
      {desc.additionalText && (
        <div className="r_detailsAdditionalText">
          <div className="r_importantNoticeTitle">
            {playdetailsv2_resources.ImportantNotice}
          </div>
          <div dangerouslySetInnerHTML={{ __html: desc.additionalText }} />
        </div>
      )}
    </div>
  );
};

export default Notice;
